"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firebaseIsPathLinkValid = (link) => {
    if (link.startsWith(' ')) {
        return `Path parth "${link}" must to be a string without starting spaces`;
    }
    if (link.endsWith(' ')) {
        return `Path parth "${link}" must to be a string without ending spaces`;
    }
    const valid = /^[=a-zA-Z0-9_-\s]+$/.test(link);
    if (!valid) {
        return `Path part "${link}" must to be a string that matches with the regular expression /^[a-zA-Z0-9_-=\\s]+$/`;
    }
    return undefined;
};
exports.default = firebaseIsPathLinkValid;
